import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";

import "bootstrap";
import "simplebar";

import "../src/frontend.scss";
import "controllers";

Rails.start();
Turbolinks.start();
ActiveStorage.start();

window.Rails = Rails;
